import { DeliveryStatisticApi } from 'api/DeliveryStatisticApi';
import { backendApiClient } from 'container/backendApiClient';

export const deliveryStatisticApi = new DeliveryStatisticApi(backendApiClient);
